@use "../../design-tokens/border-radius/border-radius" as *;
@use "../../design-tokens/typography/typography" as *;
@use "../custom-scroll/custom-scroll" as *;

$timing-function-base: cubic-bezier(0.4, 0, 0.2, 1);

@layer design-system {
  .asideExpandable {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    border-right: 1px solid var(--border-soft);
    height: 100%;
    transition: width 0.3s $timing-function-base;
    background-color: var(--background-soft);
    z-index: var(--z-index-sidebar);
    padding: 20px 8px;
    width: 48px;

    &.isExpanded {
      width: 260px;
    }
  }

  .header {
    @include typography-v2-title-base;
    padding-left: 8px;
    white-space: nowrap;
  }

  .toggleButtonWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .actionButtonWrapper {
    @include typography-v2-body-sm;
    @include border-radius-r2;
    display: flex;
    align-items: center;
    border: none;
    background: none;
    cursor: pointer;
    outline: none;
    width: 100%;
    height: auto;
    gap: 8px;
    padding: 6px 8px;
    margin-top: 8px;
    color: var(--text-default);
    white-space: nowrap;

    &:hover,
    &:focus-visible {
      background-color: var(--surface-hover);
    }
  }

  .toggleButton {
    background-color: var(--background-soft);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;

    &:hover,
    &:focus-visible {
      border-color: var(--surface-hover);
      background-color: var(--surface-hover);
    }

    &.isExpanded {
      transform: rotate(180deg);
    }
  }

  .actionButton {
    width: 32px;
    height: 32px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    background-color: var(--background-soft);

    &:hover,
    &:focus-visible {
      border-color: var(--surface-hover);
      background-color: var(--surface-hover);
    }
  }

  .separator {
    height: 1px;
    width: 100%;
    margin-top: 16px;
    background-color: var(--border-soft);
    border: none;
  }

  .categories {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    overflow: clip auto;
    @include custom-scroll-minimal;
    gap: 4px;

    &.bottom {
      margin-top: auto;
    }

    &.isExpanded [class*="mainLabel"] {
      opacity: 1;
    }
  }
}
